import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { SmartintegService } from '../../../../services/smartinteg.service';
import { ToastService } from '../../../../services/toast.service';
import { Provedor, ProvedorConexao } from '../../../../types/smartinteg';

@Component({
  selector: 'app-provedor-conexoes',
  templateUrl: './provedor-conexoes.component.html',
  styleUrls: ['./provedor-conexoes.component.css'],
  providers: [ConfirmationService]
})
export class ProvedorConexoesComponent implements OnInit {

  provedorId!: string;
  provedor: Provedor | null = null;
  conexoes: ProvedorConexao[] = [];
  loading: boolean = true;

  // Flags para dialogs
  conexaoDialog: boolean = false;
  submitted: boolean = false;
  isEditDialog: boolean = false;
  
  // Exemplo de uma conexão para o form
  conexao: ProvedorConexao = {} as ProvedorConexao;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private smartintegService: SmartintegService,
    private toastService: ToastService,
    private confirmationService: ConfirmationService
  ) { }

  ngOnInit(): void {
    this.provedorId = this.route.snapshot.paramMap.get('provedorId')!;
    if (this.provedorId) {
      this.carregarProvedor();
      this.carregarConexoes();
    } else {
      this.toastService.erro('Erro', 'ID do provedor não encontrado.');
      this.voltar();
    }
  }

  carregarProvedor(): void {
    this.smartintegService.buscarProvedor(this.provedorId).subscribe({
      next: (data) => this.provedor = data,
      error: (err) => this.toastService.erro('Erro', 'Falha ao buscar dados do provedor.')
    });
  }

  carregarConexoes(): void {
    this.loading = true;
    this.smartintegService.listarConexoesPorProvedor(this.provedorId).subscribe({
      next: (data) => {
        this.conexoes = data;
        this.loading = false;
      },
      error: (err) => {
        this.toastService.erro('Erro', 'Falha ao carregar conexões.');
        this.loading = false;
      }
    });
  }

  novaConexao(): void {
    this.conexao = {} as ProvedorConexao;
    this.submitted = false;
    this.isEditDialog = false;
    this.conexaoDialog = true;
  }

  editarConexao(conexao: ProvedorConexao): void {
    this.conexao = { ...conexao };
    this.submitted = false;
    this.isEditDialog = true;
    this.conexaoDialog = true;
  }

  deletarConexao(conexao: ProvedorConexao): void {
    this.confirmationService.confirm({
      message: `Tem certeza que deseja deletar a conexão <strong>${conexao.nome}</strong>?`,
      header: 'Confirmar Exclusão',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        // Lógica de deleção aqui
      }
    });
  }

  salvarConexao(): void {
    this.submitted = true;
    // Lógica de salvar (criar ou atualizar) aqui
    
    // Exemplo de como fechar o dialog
    // this.conexaoDialog = false;
    // this.toastService.sucesso('Sucesso', 'Conexão salva.');
  }

  fecharDialog(): void {
    this.conexaoDialog = false;
    this.submitted = false;
  }

  voltar(): void {
    this.router.navigate(['/smartinteg/provedores']);
  }
}
